import { pdfCustomFieldsTranslations } from './pdf-custom-fields-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
/** Translations of the visual PDF template designer; wired up in lib/i18n/en.ts. */
export const pdfDesignerEn = {
  customFields: pdfCustomFieldsTranslations.en,
  list: {
    title: 'PDF templates',
    subtitle: 'Design document layouts without coding and assign them per document type.',
    cardTitle: 'Templates',
    cardDescription: 'The default template of a document type is applied automatically on print.',
    filter: 'Filter document type',
    allTypes: 'All document types',
    create: 'New template',
    created: 'The template has been created.',
    createTitle: 'Create template',
    createDescription: 'Choose a document type and a starting layout; both remain editable.',
    preset: 'Starting layout',
    presetHint: 'The preset defines margins, fonts, building blocks and columns.',
    active: 'Active',
    inactive: 'Inactive',
    error: 'The templates could not be loaded.',
    emptyTitle: 'No template yet',
    emptyHint: 'Create a template to design the print layout of your documents.',
    columns: {
      name: 'Name',
      documentType: 'Document type',
      status: 'Status',
      updatedAt: 'Last change',
    },
  },
  documentTypes: {
    QUOTE: 'Quotation',
    ORDER: 'Order confirmation',
    DELIVERY_NOTE: 'Delivery note',
    INVOICE: 'Invoice',
    PURCHASE_ORDER: 'Purchase order',
    ALL: 'All document types',
  },
  presets: {
    CLASSIC_DIN5008: 'Classic DIN 5008',
    MODERN_MINIMALIST: 'Modern minimalist',
    COMPACT: 'Compact',
  },
  blocks: {
    RECEIVING_HOURS: deliveryPlanningTranslations.en.receiving,
    TRANSPORT_PLAN: deliveryPlanningTranslations.en.transport,
    LOGO: 'Company logo',
    SENDER_LINE: 'Sender line',
    RECIPIENT_ADDRESS: 'Address field',
    DOCUMENT_META: 'Document data box',
    HEADER_TEXT: 'Subject line',
    CUSTOMER_HEADER: 'Customer data in header',
    ITEMS_TABLE: 'Line item table',
    SHIPPING_SUMMARY: 'Packaging and weight',
    TOTALS_BLOCK: 'Totals block',
    GIROCODE_QR: 'GiroCode QR',
    FOOTER_TEXT: 'Payment terms',
    FOOTER_COLUMNS: 'Three-column footer',
    CUSTOM_HTML_TEXT: 'Free text',
  },
  columns: {
    position: 'Item',
    sku: 'Article number',
    name: 'Description',
    description: 'Details',
    batchNumber: 'Batch',
    expiryDate: 'Best before',
    quantity: 'Quantity',
    unit: 'Unit',
    unitPrice: 'Unit price',
    discountPercent: 'Discount',
    taxRate: 'VAT rate',
    lineTotal: 'Total net',
  },
  toolbar: {
    name: 'Template name',
    isDefault: 'Default',
    unsaved: 'Unsaved changes',
    editMode: 'Edit mode',
    previewMode: 'Live PDF preview',
    undo: 'Undo',
    redo: 'Redo',
    resetPreset: 'Reset to preset',
    duplicate: 'Duplicate',
    setDefault: 'Set as default',
    save: 'Save & activate',
  },
  library: {
    title: 'Building blocks',
    usedTitle: 'Blocks in use',
    add: 'Add {{block}}',
  },
  canvas: {
    dragHandle: 'Move block',
    hide: 'Hide block',
    show: 'Show block',
    remove: 'Remove block',
    empty: 'Drag building blocks from the left column onto the page.',
    resizeColumn: 'Adjust the width of column {{column}}',
    customerHeaderConfigured: 'Fields from the saved document layout',
    customerHeaderFields: '{{count}} selected customer fields',
  },
  inspector: {
    pageTitle: 'Page',
    marginsTitle: 'Page margins (mm)',
    margin: {
      top: 'Top',
      bottom: 'Bottom',
      left: 'Left',
      right: 'Right',
    },
    typographyTitle: 'Typography',
    fontFamily: 'Font family',
    baseFontSize: 'Base size (pt)',
    lineHeight: 'Line height',
    colorsTitle: 'Colours',
    primaryColor: 'Primary colour',
    secondaryColor: 'Secondary colour',
    textColor: 'Text colour',
    din5008Title: 'DIN 5008',
    showFoldMarks: 'Show fold marks',
    showPunchMark: 'Show punch mark',
    showPageNumbers: 'Show page numbers',
    visible: 'Visible',
    pageBreakBefore: 'Page break before',
    content: 'Text',
    contentHint: 'Leave empty to use the text captured on the document.',
    positionTitle: 'Position & spacing',
    positionX: 'X (mm)',
    positionY: 'Y (mm)',
    positionWidth: 'Width (mm)',
    positionHeight: 'Height (mm)',
    paddingTop: 'Space above (mm)',
    paddingBottom: 'Space below (mm)',
    styleTitle: 'Appearance',
    fontSize: 'Font size (pt)',
    alignLabel: 'Alignment',
    bold: 'Bold',
    borderBottom: 'Bottom rule',
    background: 'Background colour',
    align: {
      left: 'Left',
      center: 'Centre',
      right: 'Right',
    },
    tableDisplayTitle: 'Table appearance',
    zebra: 'Zebra stripes',
    compact: 'Compact row spacing',
    headerBackground: 'Tint header row',
    headerColor: 'Header colour',
    columnsTitle: 'Columns',
    columnLabel: 'Label',
    totalsTitle: 'Totals block',
    showTaxBreakdown: 'Show VAT breakdown',
    showCashDiscount: 'Show cash discount',
    girocodeTitle: 'GiroCode',
    qrSize: 'Size (mm)',
    qrAlign: 'Alignment',
    qrCaption: 'Show caption',
    logoTitle: 'Logo',
    logoHeight: 'Height (mm)',
    showCompanyAddress: 'Show company address',
    paymentTitle: 'Notices',
    showPaymentTerms: 'Show payment terms',
    showTaxNotice: 'Show tax notice',
    customerHeaderTitle: 'Customer data',
    customerHeaderHint:
      'Selected public standard fields, such as VAT ID, show the saved document value. Adding a field activates the block. Custom fields still require their PDF approval.',
    customerHeaderSharedTypeHint:
      'This template covers multiple document types. Missing or unapproved fields are safely omitted per document.',
    customerHeaderColumns: 'Columns',
    customerHeaderLabels: 'Field labels',
    customerHeaderLayoutDefault: 'Use document layout',
    customerHeaderLabelsShow: 'Always show',
    customerHeaderLabelsHide: 'Values only',
    customerHeaderHideEmpty: 'Hide empty values',
    customerHeaderFields: 'Field selection',
    customerHeaderUseLayout: 'Use document layout',
    customerHeaderAllConfigured: 'All fields approved for PDF in the document layout are shown.',
    customerHeaderSelectedCount: '{{count}} fields explicitly selected',
    customerHeaderSelected: 'Selected customer fields',
    customerHeaderUnavailableField: 'Field no longer available',
    customerHeaderMoveUp: 'Move field up',
    customerHeaderMoveDown: 'Move field down',
    customerHeaderRemove: 'Remove field from selection',
    customerHeaderSearch: 'Search fields or categories',
    customerHeaderSource: 'Filter field type',
    customerHeaderCategory: 'Filter category',
    customerHeaderLoadError: 'The customer fields could not be loaded.',
    customerHeaderBlocked: 'This field must not appear on PDFs.',
    customerHeaderNoFields: 'No matching externally approved fields found.',
  },
  meta: {
    addDocument: 'Add document field',
    add: 'Add customer field',
    rows: 'Document details rows',
    hint: 'Drag rows or use the arrows to reorder them. Values, labels and PDF permissions come from the saved document. The box grows with its content; check its actual size in the PDF preview. Other blocks remain independent.',
    showLabel: 'Show field label',
    hideEmpty: 'Hide empty values',
    chooseSample: 'Select a sample document to check.',
    loadError: 'The fields or document could not be loaded. Check your read permissions.',
    emptyValue: 'Empty value',
    configureLayout: 'Configure customer header PDF permissions',
    configureFields: 'Configure custom fields',
    openDocument: 'Check saved field values in the document',
    standard: {
      documentNumber: 'Document number',
      documentDate: 'Date',
      customerNumber: 'Customer number',
      contactPerson: 'Contact person',
      reference: 'Reference',
      serviceDate: 'Service date',
      deliveryDate: 'Delivery date',
      validUntil: 'Valid until',
      dueDate: 'Due date',
    },
    issues: {
      documentMissingSnapshot:
        'No readable historical definition is available for this document field. Check the custom fields and your read permissions in the sample document. Current definitions are never substituted.',
      documentNotReleased:
        'This document field is not released for PDF in its saved definition or currently. Check “Show in PDF” under Custom fields; selecting it in a template does not grant permission.',
      unavailable:
        'This field is unavailable in the current catalog. Check the document type, field status and read permissions under custom fields.',
      missingSnapshot:
        'No saved value. Check the saved customer data in the document; explicitly add or refresh the field in a draft if needed. Current master data is never substituted.',
      notConfigured:
        'The field is missing from the saved document layout. Check the customer data selection in the document.',
      private:
        'Internal or confidential fields cannot appear in PDFs. Check the custom field classification; selecting a field in a template does not grant permission.',
      notReleased:
        'The saved document does not allow this field or section in PDFs. Check PDF permissions in the document; configure defaults for new documents under Customer header.',
      condition:
        'The saved output condition is not met or the field is protected. Check the customer data configuration in the document.',
      empty: 'The saved value is empty and hidden.',
    },
  },
  preview: {
    title: 'PDF preview',
    sample: 'Sample document',
    refresh: 'Reload preview',
    updating: 'Updating preview …',
    emptyTitle: 'No sample document available',
    emptyHint: 'Create a document of this type to see the preview.',
  },
  editor: {
    loadError: 'The template could not be loaded.',
    copyName: '{{name}} (copy)',
    resetTitle: 'Reset layout?',
    resetDescription:
      'All customisations of this template are replaced by the “{{preset}}” preset. The step can be undone.',
  },
  toast: {
    saved: 'The template has been saved.',
    duplicated: 'The template has been duplicated.',
    defaultSet: 'The template is now the default for this document type.',
  },
};
